import {
  Component
} from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
  AlertController,
  ActionSheetController,
  ToastController,
  Platform,
  ModalController,
  ViewController,
  DateTime
} from "ionic-angular";
import { AngularFirestore } from "@angular/fire/firestore";
import { DatabaseProvider } from "../../providers/database/database";
import { PdfProvider } from "../../providers/pdf/pdf";
import "rxjs/add/operator/mergeMap";
import { AuthProvider } from "../../providers/auth/auth";
import * as _ from "lodash";
import { Storage } from '@ionic/storage';
import { OrderProvider } from "../../providers/order/order";
import { PatientsPage } from "../patients/patients";
import { Subject } from "rxjs";
import {OrdersPage} from "../orders/orders";
import {UtilityProvider} from "../../providers/utility/utility";
import { Rx, Location } from "models/rx";
import { PdfRxProvider } from "../../providers/pdf/pdf_rx";
import { ENV } from "@app/env";
import moment from "moment";

@IonicPage()
@Component({
  selector: "page-patient-batch",
  templateUrl: "patient-batch.html"
})

export class PatientBatchPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  patient: any;
  order: any = {};
  public error: string;
  isUpdate: boolean = false;
  isNewPatient: boolean = false;

  public doctorList: any[];
  public clinic: any = {};
  clinic_name: string;
  clinic_id: string;
  clinic_province: string;
  clinic_order_number: string;
  user: any;
  email: any;

  doctor: any = null;
  medication: any = { name: null, lucodes: []};
  location: any = null;
  quantity: any = null;
  eye: any = null;
  lucode: any = null;
  injectiondate: any = null;
  note: any = null;

  meds: any;
  eyes: any;
  quantities: any;
  lucodes: any;
  tobra: any;

  primarylocation: any = {};

  RCO_CLINICS: string[] = ['mrMkw2yPAtggAjHVGkG2', 'ziub1XUE1ebIjPdlQDQh', 'AIptejv63rKfMnPQAauN'];

  constructor(
    private viewCtrl: ViewController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public alertController: AlertController,
    public toastCtrl: ToastController,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    public modalCtrl: ModalController,
    private storage: Storage,
    private orderService: OrderProvider,
    private pdf: PdfProvider,
    private afs: AngularFirestore,
    private utility: UtilityProvider,
    private pdfRx: PdfRxProvider
  ) {
    console.log("Version", ENV.VERSION);
    this.clinic['locations'] = [];

    this.eyes = [{'name': 'OD'},{'name': 'OS'},{'name': 'OU'}];
    this.quantities = [{'name': 'x1'},{'name': 'x2'}];
    this.lucodes = [{'name': '463/AMD'},{'name': '465/DME'},{'name': '464/CRVO'},{'name': '422/AMD'},{'name': '439/DME'},{'name': '445/CRVO'},{'name': '462/CMVM'}];

    this.patient = this.navParams.data["patientdata"];
    if (this.navParams.data['isnewpatient']) {
      this.isNewPatient = this.navParams.data['isnewpatient'];
      console.log('New Patient: ', this.isNewPatient);
    }
    this.order["patient"] = {...this.patient};

    // console.log(storage.get('RetinaOrderBatch'));
    
    this.auth.getCurrentUser().then(user => {
      this.user = user;
      this.email = user.email;
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;
      this.clinic_province = user.clinic_province ? user.clinic_province : 'ON';
      this.database.getClinic(this.clinic_id)
      .valueChanges()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((clinic) => {
        if(clinic)  {
          this.clinic = clinic;
          this.clinic_order_number = 'ORD' + this.utility.pad(this.clinic.current_order, 5, '0');
          this.primarylocation.name = this.clinic.clinic_name;
          this.primarylocation.address = this.clinic.address.address;
          this.primarylocation.city = this.clinic.address.city;
          this.primarylocation.phone_number = this.clinic.phone_number;
        }
        this.location = this.primarylocation;

        this.meds = [];
        if (this.clinic_province === 'NL') {
          this.meds.push({name: 'Eylea vial', lucodes: []});
          this.meds.push({name: 'Lucentis PFS', lucodes: []});
          this.meds.push({name: 'Lucentis vial', lucodes: []});
        } else {
          this.meds.push({name: 'Eylea vial', lucodes: [{'name': '463/AMD'},{'name': '465/DME'},{'name': '464/CRVO'},{'name': '464/BRVO'},{'name': 'Other'}]});
          this.meds.push({name: 'Eylea PFS', lucodes: [{'name': '463/AMD'},{'name': '465/DME'},{'name': '464/CRVO'},{'name': '464/BRVO'},{'name': 'Other'}]});
          this.meds.push({name: 'Lucentis PFS', lucodes: [{'name': '422/AMD'}, {'name': '439/DME'},{'name': '445/CRVO'},{'name': '445/BRVO'},{'name': '462/CMVM'},{'name': 'Other'}]});
          this.meds.push({name: 'Clindamycin PFS', lucodes: []});
          this.meds.push({name: 'Dexamethasone PFS', lucodes: []});
          this.meds.push({name: 'Ocuflox', lucodes: []});
        }
        this.meds.push({name: 'Vabysmo', lucodes: []});
        this.meds.push({name: 'Ozurdex', lucodes: []});
        this.meds.push({name: 'Avastin', lucodes: []});
        this.meds.push({name: 'Beovu', lucodes: [{'name': '620/AMD'}]});
        this.meds.push({name: 'Triesence', lucodes: []});

        this.database.getDoctorsByClinic(this.clinic_id)
          .snapshotChanges()
          .takeUntil(this.ngUnsubscribe)
          .map(actions => {
            return actions.map(a => {
              const data = a.payload.doc.data() as any;
              data.id = a.payload.doc.id;
              return data;
            });
          }).subscribe((doctors) => {
          this.doctorList = doctors;

          if (this.doctorList.length === 1)
            this.doctor = this.doctorList[0];

          let rx_data = this.navParams.get('rx');
          if (rx_data) {
            console.log(rx_data);
            this.isUpdate = true;

            this.doctor = this.doctorList.filter((doc) => doc.id === rx_data.doctor.id)[0];
            this.location = this.primarylocation.name === rx_data.location.name?
              this.primarylocation :
              this.clinic.locations.filter((location) => location.name === rx_data.location.name)[0];
            this.medication = this.meds.filter((med) => med.name === rx_data.medication[0].name)[0];
            this.eye = rx_data.eye;
            this.note = rx_data.note;
            this.lucode = rx_data.lucode;
            this.tobra = rx_data.tobra === 'Tobramycin 1-2 GTTS AE Q4H x 3D POST INJ';
            this.injectiondate = null;

            this.order.rx_id = rx_data.rx_id;

            this.updateOrder();
          }
        });
      });
    });
  }

  ngOnDestroy() {
    console.log('Leave patient add rx to batch and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  updateOrder() {
    this.order.doctor = this.doctor;
    this.order.location = this.location;
    this.order.medication = this.medication.name;
    this.order.eye = this.eye;
    this.order.note = this.note;
    this.order.injectiondate = null;

    if (this.eye === 'OD' || this.eye === 'OS') {
      this.order.quantity = '1x';
      this.order.quantity_numeric = 1;
      this.quantity = '1x';
    } else {
      this.order.quantity = '2x';
      this.order.quantity_numeric = 2;
      this.quantity = '2x';
    }

    if (this.medication.name === 'Ozurdex' || this.medication.name === 'Avastin' ||
      this.medication.name === 'Clindamycin PFS' || this.medication.name === 'Dexamethasone PFS' || this.medication.name === 'Triesence') {
      this.order.lucode = 'NA';
    } else if (this.medication.name === 'Ocuflox'){
      this.order.lucode = '170';
    } else {
      this.order.lucode = this.lucode ? this.lucode : 'NA';
    }
  }

  async reviewOrder() {
    this.updateOrder();
    let canSave: boolean = true;
    let errorMsg: string = null;
    if (!this.order.doctor) {
      canSave = false;
      errorMsg = "You must select a doctor before proceeding";
    } else if (!this.order.medication) {
      canSave = false;
      errorMsg = "You must select a medication before proceeding";
    } else if (!this.order.eye) {
      canSave = false;
      errorMsg = "You must choose an eye";
    } else if (!this.order.quantity) {
      canSave = false;
      errorMsg = "You must choose a quantity";
    } else if (this.lucode === 'Other' && this.order.note === null) {
      canSave = false;
      errorMsg = "Please enter a note if LU does not apply for this patient";
    } else if (!this.order.lucode && this.clinic_province !== 'NL') {
      console.log(this.order.lucode);
      canSave = false;
      errorMsg = "You must choose an LU Code";
    } else if (!this.utility.isPatientDOBCorrect(this.order.patient)) {
      canSave = false;
      errorMsg = "This patient has an incorrectly formatted date of birth. "+this.order.patient.dob+"<br><br>Please fix it before submitting Rx."
    }

    if (!canSave) {
      let alert = this.alertController.create({
        title: "Order Issue",
        subTitle: errorMsg,
        buttons: ["OK"]
      });
      alert.present();
    } else {
      if (!this.order.lucode) {
        this.order.lucode = 'NA'
      }
      let ordermessage: string =
        "Please review your final order before submitting.<br/><br/>" +
        "Order for " + this.patient.first_name + " " + this.patient.last_name +
        "<br/><br/>" +
        "<strong>Doctor: </strong>Dr. " +
        this.order.doctor.last_name + "<br/>";

      ordermessage += "<strong>Medication: </strong>";
      ordermessage += this.order.medication + '<br/>';
      ordermessage += "<strong>Eye: </strong>";
      ordermessage += this.order.eye + "<br/>";
      ordermessage += "<strong>Quantity: </strong>";
      ordermessage += this.order.quantity + "<br/>";
      ordermessage += "<strong>LU Code: </strong>";
      ordermessage += this.order.lucode + "<br/>";

      if (this.tobra) {
        this.order.tobra = 'Tobramycin 1-2 GTTS AE Q4H x 3D POST INJ';
        ordermessage += '<strong>Plus:</strong> Tobramycin 1-2 GTTS AE Q4H x 3D POST INJ<br/>';
      }else {
        delete this.order.tobra;
      }

      // let order_batch = await this.storage.get('RetinaOrderBatch');
      // order_batch = order_batch ? order_batch : [];
      // if (!this.isUpdate) {
      //   all:
      //     for (let batch of order_batch) {
      //       for (let rx of batch.rx) {
      //         if (rx.patient.id === this.order.patient.id) {
      //           ordermessage = "<b>Warning: there is already an rx for this patient in this order</b><br><br>".concat(ordermessage);
      //           break all;
      //         }
      //       }
      //     }
      // }
      const currentPatientLastFilledRx = await this.database.getPrescriptionsByPatientFilledCount(this.clinic_id, this.patient.id);
      if (currentPatientLastFilledRx.length === 1) {
        if (moment().add(-1, 'month').isBefore(currentPatientLastFilledRx[0]['filled_date'].toDate())) {
          ordermessage = `<b style='background-color: red; border-radius: 4px; color: white; font-weight: bold;'>Warning: A prescription for this patient was filled in the last month in Order: ${currentPatientLastFilledRx[0]['order_number']}</b><br/><br/>`.concat(ordermessage);
        }
      }

      const currentPatientBatchCount = await this.database.getOrdersByPatientBatchedCount(this.clinic_id, this.patient.id);
      console.log('Current rx for patient', currentPatientBatchCount);
      let message = '';
      if (currentPatientBatchCount > 0) {
        ordermessage = "<b style='color: red; font-weight: bold;'>Warning: there is already an rx for this patient in this order</b><br><br>".concat(ordermessage);
      }

      let confirm = this.alertController.create({
        title: "Review Rx",
        message: ordermessage,
        cssClass: "patient-batch-alert",
        buttons: [
          {
            text: "Cancel",
            handler: () => {
            }
          },
          {
            text: "Submit Rx Order",
            handler: async () => {
              let loading = this.loadingCtrl.create({});
              loading.present();

              // const batchname = this.order.doctor.id + '_' + this.order.doctor.last_name;
              // const new_order = {'order_batch': batchname, 'signature': this.order.doctor.signature};
              // this.order.doctor.signature = null;
              // delete this.order.patient.last_rx;
              // this.order.nursing_home_id = await this.utility.getNursingHomeId(this.order).take(1).toPromise();


              // new_order['rx'] = [this.order];
              console.log(this.order.location.name);
              const newRx = <Rx>{};
              if (this.order.rx_id) {
                newRx.rx_id = this.order.rx_id;
              }
              else {
                newRx.rx_id = this.database.createId();
              }
              newRx.software_version = ENV.VERSION;
              newRx.clinic_id = this.clinic_id;
              newRx.clinic_name = this.clinic_name;
              newRx.clinic_province = this.clinic_province;
              newRx.createdAt = Date.now();
              newRx.updatedAt = newRx.createdAt;
              newRx.doctor = this.order.doctor;
              newRx.doctor_id = this.order.doctor.id;
              newRx.eye = this.order.eye;
              newRx.filled = false;
              newRx.injectiondate = null;
              newRx.location = this.order.location;
              newRx.lucode = this.order.lucode ? this.order.lucode : null;
              newRx.medication = [
                {
                  category: null,
                  createdAt: null,
                  din: this.database.dins[this.order.medication],
                  name: this.order.medication
                }
              ];
  
              if (this.order.tobra) {
                newRx.medication.push({category: null, createdAt: null, din: "02241755", name: "Tobramycin"})
              }
              newRx.medication_name = this.order.medication;
              newRx.note = this.order.note ? this.order.note : null;
              newRx.nursing_home = `${this.order.doctor.first_name} ${this.order.doctor.last_name} - ${newRx.location.name}`;
              newRx.nursing_home_id = await this.utility.getNursingHomeId(this.order).take(1).toPromise();
              // newRx.order_number_clinic = this.clinic_order_number;
              // const order_number_clinic = `ORD${this.utility.pad(await this.database.getUniqueClinicOrderNumber(this.clinic_id),5, '0')}`;
              // this.order.clinic_name = this.clinic_name;
              // this.order.clinic_id = this.clinic_id;
              // this.order.clinic_province = this.clinic_province;
              // newRx.order = {
              //   "id": newRx.rx_id,
              //   "number": order_number_clinic
              // };
              // newRx.order_number_clinic = order_number_clinic;
              // newRx.order_number_master = await this.database.getUniqueMasterOrderNumber();
              newRx.patient = this.order.patient;
              delete newRx.patient._highlightResult;
              delete newRx.patient.last_rx;
              if (newRx.patient.phone_number )  {
                newRx.patient.phone_number_primary = newRx.patient.phone_number
              }
              newRx.patient_id = this.order.patient.id;
              newRx.quantity = this.order.quantity;
              newRx.quantity_numeric = this.order.quantity_numeric;
              newRx.status = "Batch";
              newRx.tobra = this.order.tobra ? this.order.tobra : null;
              newRx.createdBy = this.email;
              const rxUrl = await this.pdfRx.createRxPDF(newRx);
              newRx.prescription_image = {
                path: `prescriptions/${newRx.clinic_name}_${newRx.patient.last_name}_${newRx.createdAt}.pdf`,
                type: 'pdf',
                url: rxUrl
              }
              console.log('New Rx: ', newRx);
              this.database.setDocWithExistingID('prescriptions', newRx.rx_id, newRx)
              .then(() => {
                console.log('completed saving');
                loading.dismiss().then(() => {
                  if (this.isNewPatient)  {
                    this.navCtrl.setRoot(PatientsPage);
                  } else {
                    this.navCtrl.pop();
                  }
                });
              })
              .catch(err => {
                console.log('saving failed', err);
                loading.dismiss();
              })
              // if (this.isUpdate) {
              //   this.storage.get('RetinaOrderBatch').then((order_batch) => {
              //     for (let batch of order_batch) {
              //       for (let rx of batch.rx) {
              //         if (rx.rx_id === this.order.rx_id) {
              //           Object.assign(rx, this.order);
              //           if (!this.tobra)
              //             delete rx.tobra;
              //           console.log(order_batch);
              //           console.log(this.order)
              //         }
              //       }
              //     }

              //     this.storage.set('RetinaOrderBatch', order_batch).then(() => {
              //       loading.dismiss().then(() => {
              //         this.navCtrl.pop();
              //       })
              //     });
              //   })
              // } else {
              //   this.order.rx_id = this.afs.createId();

              //   this.storage.get('RetinaOrderBatch').then((order_batch) => {
              //     if (order_batch) {
              //       this.checkBatch(order_batch)
              //         .then((idx) => {
              //           let index = parseInt(idx.toString());
              //           order_batch[index]['rx'].push(this.order);
              //           this.storage.set('RetinaOrderBatch', order_batch).then(() => {
              //             loading.dismiss().then(() => {
              //               if (this.isNewPatient)  {
              //                 this.navCtrl.setRoot(PatientsPage);
              //               } else {
              //                 this.navCtrl.pop();
              //               }
              //               this.orderService.updateBadge();
              //             });
              //           });
              //         })
              //         .catch((error) => {
              //           order_batch.push(new_order)
              //           this.storage.set('RetinaOrderBatch', order_batch).then(() => {
              //             loading.dismiss().then(() => {
              //               this.dismiss();
              //               this.orderService.updateBadge();
              //             });
              //           });
              //         });
              //     } else {
              //       let base_order: any = [];
              //       base_order.push(new_order);
              //       this.storage.set('RetinaOrderBatch', base_order).then(() => {
              //         loading.dismiss().then(() => {
              //           this.dismiss();
              //           this.orderService.updateBadge();
              //         });
              //       });
              //     }
              //   });
              // }
            }
          }
        ]
      });
      confirm.present();
    }
  }

  checkBatch(order_batch)  {
    return new Promise((resolve, reject) => {
      _.forEach(order_batch, (batch, idx) => {
        if(batch.order_batch === this.order.doctor.id + '_' + this.order.doctor.last_name)  {
          resolve(idx)
        }
      });
      reject(null);  
    });
  }

  dismiss() {
    this.navCtrl.setRoot(PatientsPage);
  }

  eraseLucodes() {
    this.lucode = null;
  }

  RCOExempt() {
    this.note = "RCO Exempt";
  }
}



// WEBPACK FOOTER //
// ./src/pages/patient-batch/patient-batch.ts